// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-1ATbW","bottom_title":"bottom_title-2uzAP"};